import { Capacitor } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'

export async function initPushNotifications(
  onTokenReceived: (data: { deviceToken: string; platform: string }) => void
) {
  if (!['ios', 'android'].includes(Capacitor.getPlatform())) {
    return
  }

  const permStatus = await PushNotifications.requestPermissions()
  if (permStatus.receive !== 'granted') {
    return
  }

  await PushNotifications.addListener('registration', token => {
    onTokenReceived({ deviceToken: token.value, platform: Capacitor.getPlatform() })
  })

  await PushNotifications.addListener('pushNotificationActionPerformed', () => {
    // TODO: Handle the action performed by the user
  })

  await PushNotifications.register()
}
